<template>
  <div class="agent_list_style batch_btn" :style="screenHeight">
    <div class="fixed_search">
      <div class="fixed_search_input">
        <Input v-model="flowName" placeholder="请输入流程名称" title="流程名称" />
      </div>
      <div class="fixed_search_input">
        <Select v-model="rtId" placeholder="请选择语音模型" clearable>
          <Option v-for="(option,index) in aiTemplateList" :value="option.id" :key="index">{{option.tName}}</Option>
        </Select>
      </div>

      <!--buttons-->
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" @click="reset" class="operation_btn reset_btn">重置</Button>
        <Button type="success" style="margin-left: 10px" class="search_btn" @click="addFlow" v-if="roleList['a_2-1']">添加</Button>
      </div>
    </div>
    <!--table area-->
    <div style="border-bottom: 1px solid rgb(235, 238, 245);" class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon><div>正在加载中....</div></Spin>
      <div class="table_head">
        <table>
          <tr>
            <th class="font_style_set" style="width: 20%">流程名称</th>
            <th class="font_style_set" style="width: 15%">语音模型</th>
            <th class="font_style_set" style="width: 15%">TTS声音</th>
            <th class="font_style_set" style="width: 20%">流程简介</th>
            <th class="font_style_set" style="width: 10%">发布</th>
            <th class="font_style_set" style="width: 20%;border-right: 0px">操作</th>
          </tr>
        </table>
      </div>
      <div class="footer_style" :style="tableHeight">
        <table class="table_head_footer">
          <tr v-for="(item,index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
            <td style="width: 20%" class="telephone" @click="openFlow(item)">{{item.rwName}}</td>
            <td style="width: 15%" :title="item.tName">{{item.tName}}</td>
            <td style="width: 15%" :title="item.vDescr">{{item.vDescr}}</td>
            <td style="width: 20%" :title="item.rwDescr">{{item.rwDescr}}</td>
            <td style="width: 10%" class="telephone" @click="publishOrDown(item.id,item.publish)">{{item.publish}}</td>
            <td class="template_table_btn" style="width: 20%">
              <span class="search_btn" @click="editFlow(item.id)" v-if="roleList['a_2-2']">编辑</span>
              <span class="search_btn" @click="deleteFlow(item.id)" v-if="roleList['a_2-5']">删除</span>
              <span class="search_btn" @click="classifyFlow(item.id)" v-if="roleList['a_2-3']">分类</span>
              <span class="search_btn" @click="copyFlow(item.id)" v-if="roleList['a_2-6']">复制流程</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size="pageSize" :current="currentPage" :page-size-opts="pageSizeList" show-total show-sizer @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px">页</div>
    </div>
    <AIFlowEditPop @closeAIFlowEditPop="closeAIFlowEditPop" :showFlow="showFlow" :flowId="flowId" :showTitle="showTitle" :templateList="aiTemplateList" :ttsVoices="ttsVoices"></AIFlowEditPop>
    <AIFlowCopy :flowId="flowId" :templateList="aiTemplateList" :ttsVoices="ttsVoices" :showCopy="showCopy" @closeAIFlowCopyPop="closeAIFlowCopyPop"></AIFlowCopy>
    <AITagPop :show="showTag" @closeDialog="closeAITag" :flowId="flowId"></AITagPop>
  </div>
</template>

<script>
  import {publicFunClass} from "@/components/js/PublicFunClass.js";
  import AIFlowEditPop from "./AIFlowEditPop";
  import eventBus from "../../util/eventBus";
  import AIFlowCopy from "./AIFlowCopy";
  import AITagPop from './AITagPop'

  export default {
    name: "AIFlowListing",
    mixins: [publicFunClass],
    components: {AITagPop, AIFlowCopy, AIFlowEditPop},
    props:{
      pageCode:String
    },
    data(){
      return {
        showPageCount:0,
        total:0,
        pageSizeList:[10,20,30,40,50,100,200],
        currentPage:1,
        speedChangePage:1,
        pageSize:20,
        flowName:'',
        rtId:'',
        aiVoiceTemplate:'',
        screenHeight:{height:''},
        spinShow:true,
        roleList: JSON.parse(localStorage.getItem("roleList")),
        showTitle: '添加流程',
        showFlow:false,
        showTag:false,
        flowId:'',
        tableHeight:{height: ''},
        singleCheckedList:[],
        infoTableList:[],
        aiTemplateList:[],
        ttsVoices:[],
        menuId:'null',
        journalType:'null',
        configInfo:JSON.parse(localStorage.getItem("configInfo")),
        breadList: JSON.parse(localStorage.getItem("breadList")),
        showCopy:false,
        lastItem:undefined,
      }
    },
    methods:{
      addFlow() {
        this.showFlow=true
        this.flowId=''
        this.showTitle='添加流程'
      },
      openFlow(item) {
        if (this.roleList['a_2-8']) {
          //获取是否打开了流程绘制的页面
          if (this.lastItem) {
            if (this.lastItem !== item) {
              this.$emit('openTips', true, item);
              return
            }
          }
          this.$emit("showStandardPage", "a_2-8,流程绘制", item.id);
          eventBus.$emit('editFlow', item)
          this.lastItem = item
        } else {
          this.$Message.info("您没有编辑流程的权限，请联系管理员！");
        }
      },
      publishOrDown(flowId,state) {
        if (this.roleList['a_2-9']) {
          let msg = "是否发布？"
          let successMsg = "发布成功！"
          let param = {flowId:flowId,type:'PUBLISH'}
          if (state === '已发布') {
            param.type = 'DOWN'
            msg = "是否下线？"
            successMsg = "下线成功！";
            param.menuId = 'a_2-9'
            param.journalType = 'AI机器人管理=>AI流程管理=>流程下线'
          }else if (state === '未发布') {
            param.type = 'PUBLISH'
            msg = "是否发布？"
            successMsg = "发布成功！"
            param.menuId = 'a_2-9'
            param.journalType = 'AI机器人管理=>AI流程管理=>流程发布'
          }
          let that = this
          this.$Modal.confirm({
            title:'提示',
            content:msg,
            onOk:()=>{
              that.$http.post('/AI/WorkFlow/publishOrDown',param).then(res=>{
                let response = res.data
                if (response.flag != '666') {
                  that.$alert(response.msg,'提示',{
                    confirmButtonText: '确定'
                  })
                  return false
                }
                that.$Message.info(successMsg)
                that.initSearch()
              })
            }
          })
        } else {
          this.$Message.info('您没有发布权限，请联系管理员！');
        }
      },
      editFlow(id) {
        this.showFlow=true
        this.flowId=id+''
        this.showTitle='编辑流程'
      },
      closeAIFlowEditPop(flag){
        this.showFlow=false
        if (!flag) {
          this.initSearch()
        }
      },
      closeAITag(value) {
        this.showTag=false
      },
      closeAIFlowCopyPop(value) {
        this.showCopy=false
        this.initSearch()
      },
      deleteFlow(id) {
        let param = {
          journalType: 'AI智能机器人管理=>AI流程设置=>删除流程',
          menuId:'a_2-5',
          id:id
        }
        let that = this
        this.$Modal.confirm({
          title:'提示',
          content:'是否确认删除',
          onOk:()=>{
            that.$http.post('/AI/WorkFlow/deleteById',param).then(res=>{
              let response = res.data
              if (response.flag != '666') {
                that.$alert(response.msg,'提示',{
                  confirmButtonText: '确定'
                })
                return false
              }
              that.$Message.info('删除成功')
              that.initSearch()
            })
          }
        })
      },
      classifyFlow(id) {
        this.flowId = id + ''
        this.showTag = true
      },
      copyFlow(id) {
        this.flowId = id+''
        this.showCopy = true
      },
      initSearch(){
        let that = this
        this.spinShow = true
        let param = {
          rwName:this.flowName,
          rtId:this.rtId,
          pageNum: this.currentPage,
          pageSize: this.pageSize,
          journalType: 'null',
          menuId: 'null'
        }
        this.$http.post('/AI/WorkFlow/queryList',param).then(res=>{
          that.spinShow = false
          let response = res.data
          if(response.flag!="666"){
            that.$Modal.info({
              title:'提示',
              content:res.data.msg
            });
            return false;
          }
          that.infoTableList = response.obj.content
          that.total=response.obj.totalSize
        })
      },
      reset(){
        this.flowName = ''
        this.rtId = ''
      },
      initAITemplate() {
        let that = this
        let param = {
        }
        this.$http.post('/AI/WorkFlow/queryTemplates',param).then(res=>{
          let response = res.data
          if(response.flag!="666"){
            console.log("init template data error",response.msg)
          }
          that.aiTemplateList = response.obj
        })
      },
      initVoice() {
        let that = this
        let param = {
        }
        this.$http.post('/AI/WorkFlow/queryTTSVoice',param).then(res=>{
          let response = res.data
          if(response.flag!="666"){
            console.log("init template data error",response.msg)
          }
          that.ttsVoices = response.obj
        })
      }
    },
    created() {
      this.screenHeight.height = this.mountHeight(91)
      this.tableHeight.height = this.mountHeight(225)
      //this.initSearch()
      let that = this
      eventBus.$on('openEditFlow',(res,item)=>{
        if (res) {
          if (item) {
            that.$emit("showStandardPage", "a_2-8,流程绘制", item.id);
            eventBus.$emit('editFlow', item)
            that.lastItem = item
          }

        }
      })
      this.initAITemplate()
      this.initVoice()
    },
    watch:{
      pageCode:{
        deep:true,
        handler() {
          if (this.pageCode == 'a_2' && this.showPageCount == 0) {
            this.showPageCount++
            this.initSearch()
          }
        }
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/aiManager/AIFlowListing.vue